import React from "react";
import { useState } from "react";
import { Modal, Button } from "antd";
import "antd/dist/antd.css";
import { increaseNotification } from "./../../Redux/Actions";
import { useDispatch } from "react-redux";

function Modall(props) {
  const dispatch = useDispatch();

  const [isModalVisible, setIsModalVisible] = useState(false);

  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleOk = () => {
    addNotification();
    props.handleAddToCart();
    setIsModalVisible(false);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const addNotification = () => {
    dispatch(increaseNotification());
  };

  return (
    <div className="modal-cart">
      <Button type="primary bg-dark" onClick={showModal}>
        <i className="fas fa-shopping-cart"></i> ADD TO CART
      </Button>
      <Modal
        title="Basic Modal"
        visible={isModalVisible}
        onOk={handleOk}
        onCancel={handleCancel}
      >
        Are u sure to add item to cart
      </Modal>
    </div>
  );
}

export default Modall;
